import ReactQueryProvider from '@/API/ReactQueryProvider';
import UserImg from '@/pages/views/UserImg';
import React from 'react';

const UserImgHeader = ({ logo }) => {
  return (
    <ReactQueryProvider>
      <UserImg logo={logo} />
    </ReactQueryProvider>
  );
};
export default UserImgHeader;
